<template>
  <div class="container">
    <h1 class="py-4">取引実績サマリ</h1>
    <div>
      <div v-if="loading" class="form-row">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table id="batchTable" :items="batchDates" thead-class="hidden">
          <template #cell(date)="data">
            <router-link
              :to="{
                name: 'TransactionRecordSummaryDetails',
                query: {
                  year: data.item.date.slice(0, 4),
                  month: data.item.date.slice(4, 6),
                },
              }"
              >{{ data.item.date.slice(0, 4) }}年{{
                data.item.date.slice(4, 6)
              }}月</router-link
            >
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";

export default {
  name: "TransactionRecordSummary",
  mixins: [utils, master],
  data() {
    return {
      db: firebase.firestore(),
      batchDates: [],
      loading: true,
    };
  },
  created: function() {
    this.loading = true;
    this.loadData();
  },
  methods: {
    async loadData() {
      const query = this.db.collection("batchTransactions").orderBy('year').orderBy('month');
      const snapshot = await query.get();
      snapshot.forEach(async (doc) => {
        this.batchDates.push({
          date: doc.id,
        });
      });
      this.loading = false;
    },
  },
};
</script>